import { buildHtml, KitchenSinkRoute, RouteSlotInput } from '@luks/ui';

export function mapParagraphAccordion(
  input: ParagraphAccordionFragment,
): RouteSlotInput<typeof KitchenSinkRoute, 'body', 'Faq'> {
  return {
    key: 'Faq',
    input: {
      heading: '',
      faqs: input.accordionElements
        .filter((el) => !!el.textHtml)
        .map((el) => ({
          title: el.title || '',
          Content: buildHtml(el.textHtml!),
        })),
    },
  };
}
